// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=checkbox][data-v-9c678ca2] {\n    opacity: 1;\n    position: initial;\n}\n.item[data-v-9c678ca2] {\n    font-size: 16px;\n    margin: 0px;\n    font-weight: normal;\n    display: inline;\n}\n", ""]);
// Exports
module.exports = exports;
